import { motion } from 'framer-motion'
import { Download, ExternalLink } from 'lucide-react'
import SEO from '@/components/SEO'

const RESUME_URL = '/Rapheal-Kwabena-Resume.pdf'

export default function ResumePage() {
    return (
        <div className="min-h-screen font-mono py-12">
            <SEO
                title="Resume | Rapheal Kwabena Asomani Gadoh — Software Engineering CV"
                description="View and download the official CV/Resume of Rapheal Kwabena Asomani Gadoh — Full Stack Engineer, Open Source Creator, and STEM Educator."
                canonical="https://resume.raphealgadoh.me/"
            />
            <div className="max-w-4xl mx-auto px-6 space-y-8">

                {/* ── Header ── */}
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <h1 className="text-sm mb-1">
                        <span className="text-primary">rapheal@portfolio</span>
                        <span className="text-[#444]">:~$</span>
                        <span className="text-foreground ml-2">open resume.pdf</span>
                    </h1>
                    <p className="text-xs text-[#555]">// Rapheal-Kwabena-Resume.pdf</p>
                </motion.div>

                {/* ── Action buttons ── */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.15 }}
                    className="flex flex-wrap gap-3"
                >
                    <a
                        href={RESUME_URL}
                        download="Rapheal-Kwabena-Resume.pdf"
                        className="btn-term-accent text-xs flex items-center gap-1.5"
                    >
                        <Download className="w-3.5 h-3.5" />
                        [ download pdf ]
                    </a>
                    <a
                        href={RESUME_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-term text-xs flex items-center gap-1.5"
                    >
                        <ExternalLink className="w-3.5 h-3.5" />
                        [ open in new tab ]
                    </a>
                </motion.div>

                {/* ── Terminal PDF viewer window ── */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.25, duration: 0.5 }}
                >
                    <div className="terminal-window">
                        {/* Titlebar */}
                        <div className="terminal-titlebar">
                            <span className="terminal-dot bg-[#ff5f57]" />
                            <span className="terminal-dot bg-[#ffbd2e]" />
                            <span className="terminal-dot bg-[#28c840]" />
                            <span className="ml-3 text-[10px] text-[#444] flex-1 truncate">
                                Rapheal-Kwabena-Resume.pdf
                            </span>
                            <a
                                href={RESUME_URL}
                                download="Rapheal-Kwabena-Resume.pdf"
                                className="text-[10px] text-primary hover:underline flex items-center gap-1"
                            >
                                <Download className="w-2.5 h-2.5" />
                                save
                            </a>
                        </div>

                        {/* Embedded PDF */}
                        <iframe
                            src={`${RESUME_URL}#toolbar=0&navpanes=0&scrollbar=1`}
                            title="Rapheal Kwabena Asomani Gadoh — Resume"
                            className="w-full border-0"
                            style={{ height: 'min(88vh, 1100px)', minHeight: '600px' }}
                        />
                    </div>

                    <p className="text-center text-[10px] text-[#444] mt-3 font-mono">
                        Can't see the preview?{' '}
                        <a href={RESUME_URL} target="_blank" rel="noopener noreferrer"
                            className="text-primary hover:underline">
                            click here to open directly.
                        </a>
                    </p>
                </motion.div>

            </div>
        </div>
    )
}
